module.exports = __webpack_public_path__ + "static/media/img1.3663f457.png";